import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import Tooltip from "rc-tooltip";

export const HomeCertification = () => {
  const { t } = useTranslation();
  // const nav = useNavigate();
  const certifications = [
    {
      imgUrl: "//files.authing.co/authing-website/home-logo-iso.png",
      alt: "iso",
      tooltip: t("page.other.brand.item-one"),
    },
    {
      imgUrl: "//files.authing.co/authing-website/home-logo-jdpr.png",
      alt: "jdpr",
      tooltip: t("page.other.brand.item-two"),
    },
    {
      imgUrl: "//files.authing.co/authing-website/home-logo-soc.png",
      alt: "soc",
      tooltip: t("page.other.brand.item-tree"),
    },
    {
      imgUrl: "//files.authing.co/authing-website/home-logo-djcp.png",
      alt: "djcp",
      tooltip: t("page.other.brand.item-four"),
    },
    {
      imgUrl:
        "//files.authing.co/authing-website/hone-logo-country-height-tech.png",
      alt: "iso",
      tooltip: t("page.other.brand.item-five"),
    },
  ];
  return (
    <div className="home-others">
      <section className="inner">
        <div className="certification-title">
          <div className="line-top"></div>
          <div className="line-top-text">{t("home.certification.title")}</div>
          <div className="line-top"></div>
        </div>
        <div className="brand-warp">
          <div className="in-inner">
            {certifications.map((item) => (
              <Tooltip
                placement="bottom"
                mouseLeaveDelay={0.001}
                trigger={["hover"]}
                overlay={item.tooltip}
                overlayInnerStyle={{
                  // marginBottom: 0,
                  paddingBottom: 0,
                  // paddingTop: 18,
                }}
                overlayStyle={
                  {
                    // margin: "0px",
                  }
                }
              >
                <div className="item">
                  <div className="brand">
                    <img src={item.imgUrl} alt={item.alt} />
                  </div>
                </div>
              </Tooltip>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
